module.exports = __webpack_public_path__ + "static/media/Spinner.00a41831.svg";